/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Tag } from './Tag';
import {
    TagFromJSON,
    TagFromJSONTyped,
    TagToJSON,
    TagToJSONTyped,
} from './Tag';

/**
 * 
 * @export
 * @interface ListTagsResponse
 */
export interface ListTagsResponse {
    /**
     * 
     * @type {Array<Tag>}
     * @memberof ListTagsResponse
     */
    data: Array<Tag>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListTagsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListTagsResponse interface.
 */
export function instanceOfListTagsResponse(value: object): value is ListTagsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListTagsResponseFromJSON(json: any): ListTagsResponse {
    return ListTagsResponseFromJSONTyped(json, false);
}

export function ListTagsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTagsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TagFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListTagsResponseToJSON(json: any): ListTagsResponse {
      return ListTagsResponseToJSONTyped(json, false);
  }

  export function ListTagsResponseToJSONTyped(value?: ListTagsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TagToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

